/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @module remove-format
 */
export { default as RemoveFormat } from './removeformat.js';
export { default as RemoveFormatEditing } from './removeformatediting.js';
export { default as RemoveFormatUI } from './removeformatui.js';
import './augmentation.js';
